module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Bold.d8009bb5.woff";